import { type MetaFunction } from '@remix-run/node'
import selective from './selective.png'

export const meta: MetaFunction = () => [
	{ title: 'Selective Insurance Group' },
	{
		name: 'description',
		content: 'We offer insurance from Selective Insurance Group.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Selective</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={selective} alt="Selective Insurance Group" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Daniel Smith entered the insurance business in 1925. The company he
					formed would later become known as the Selective Insurance Group. He
					developed a reputation for being a man of his word and interested in
					the welfare of his clients. When he became dissatisfied with the
					metropolitan carriers who serviced his rural clients, and decided that
					a rural insurance company would offer better rates and service. His
					commitment to providing the best service and products has been a
					cornerstone of Selective's strategy and a key to the company's
					success. Now a publicly traded "super-regional" insurance carrier
					(Ticker Symbol "SIGI"), Selective has operations in many eastern
					states.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					In NY, the primary operations include public entities and commercial
					insurance, including Liability, Property, Auto, Worker's Compensation,
					and other coverage. In addition these offerings, they also provide
					flood insurance through the Federal Emergency Management Agency's
					Flood Insurance Program.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Strong agency relationships are one of the keys to Selectives strong
					financial position. By integrating an advanced technology
					infrastructure and vast underwriting experience, Selective has
					maintained an A.M. Best rating of “A+” (Superior) for more than four
					decades.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.selective.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.selective.com/ (opens in a new tab)
					</a>
				</p>

				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Phone: (866) 455-9969
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Selective"
						href="https://www.selective.com/info-center/pay-my-bill"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.selective.com/info-center/pay-my-bill (opens in a new
						tab)
					</a>
					<br />
					<br />
					Payment by Phone: (888) 974-7400
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Selective Insurance Group, Inc.
					<br />
					40 Wantage Avenue
					<br />
					Branchville, NJ 07890-1024
				</p>
			</section>
		</main>
	)
}
